module.exports = __webpack_public_path__ + "img/logo-invasoras-ec.b9278137.svg";